import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

// ── Icônes ───────────────────────────────────────────────────
const IconHeart = ({ size = 28, color = "#C4441A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
  </svg>
);
const IconTarget = ({ size = 28, color = "#C4441A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/>
  </svg>
);
const IconGlobe = ({ size = 28, color = "#C4441A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <circle cx="12" cy="12" r="10"/>
    <line x1="2" y1="12" x2="22" y2="12"/>
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
  </svg>
);
const IconUsers = ({ size = 28, color = "#C4441A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);
const IconStar = ({ size = 28, color = "#C4441A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
  </svg>
);
const IconShield = ({ size = 28, color = "#C4441A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
  </svg>
);
const IconCheck = ({ size = 16, color = "#3D6B2E" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);

export default function Mission() {
  const navigate = useNavigate();

  const valeurs = [
    {
      icon: <IconHeart size={26} color="#C4441A" />,
      titre: "Authenticité",
      desc: "Nous valorisons les expériences locales authentiques. Chaque hébergement, restaurant et guide que nous référençons reflète la vraie culture sénégalaise.",
    },
    {
      icon: <IconUsers size={26} color="#C4441A" />,
      titre: "Inclusivité",
      desc: "SenuTour est fait pour tous les budgets. Des palaces 5 étoiles aux villas familiales en passant par les petites auberges locales — tout le monde a sa place.",
    },
    {
      icon: <IconGlobe size={26} color="#C4441A" />,
      titre: "Impact local",
      desc: "Chaque réservation sur SenuTour profite directement aux acteurs locaux sénégalais. Pas d'intermédiaires étrangers — l'argent reste au Sénégal.",
    },
    {
      icon: <IconShield size={26} color="#C4441A" />,
      titre: "Confiance",
      desc: "Tous nos partenaires sont vérifiés. Chaque réservation est sécurisée. Nous garantissons une expérience transparente et sans mauvaise surprise.",
    },
    {
      icon: <IconTarget size={26} color="#C4441A" />,
      titre: "Innovation",
      desc: "Nous utilisons la technologie pour simplifier le tourisme au Sénégal. Paiement mobile, confirmation rapide, support 24h/24 — le tourisme du futur.",
    },
    {
      icon: <IconStar size={26} color="#C4441A" />,
      titre: "Excellence",
      desc: "Nous ne référençons que des établissements qui respectent nos standards de qualité. Votre satisfaction est notre priorité absolue.",
    },
  ];

  const chiffres = [
    { val: "14", label: "Régions couvertes", sub: "sur tout le Sénégal" },
    { val: "500+", label: "Partenaires visés", sub: "hôtels, villas, restos, guides" },
    { val: "100%", label: "Sénégalais", sub: "fondé & développé localement" },
    { val: "0 FCFA", label: "Pour s'inscrire", sub: "inscription gratuite pour tous" },
  ];

  const etapes = [
    { num: "01", titre: "Villas & Appartements", desc: "On commence par les hébergements privés — villas à Saly, appartements meublés à Dakar. Accessible, flexible, immédiat.", actif: true },
    { num: "02", titre: "Transports & Guides", desc: "Taxis aéroport, guides certifiés, navettes inter-villes. Faciliter le déplacement des touristes partout au Sénégal.", actif: false },
    { num: "03", titre: "Restaurants & Loisirs", desc: "Les meilleures tables sénégalaises, les activités incontournables. Découvrir la culture à travers la gastronomie et le divertissement.", actif: false },
    { num: "04", titre: "Hôtels & Partenariats", desc: "Les grandes chaînes hôtelières rejoignent la plateforme quand la communauté est solide. La croissance naturelle.", actif: false },
  ];

  return (
    <div style={{ fontFamily: "'Fraunces', serif", background: "#FAF5EC", color: "#1C1008", minHeight: "100vh" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,300;0,9..144,700;0,9..144,800;1,9..144,400&family=Space+Grotesk:wght@300;400;500;600;700&display=swap');
        * { margin: 0; padding: 0; box-sizing: border-box; }

        .valeur-card {
          background: white; border-radius: 16px; padding: 28px 24px;
          border: 1.5px solid rgba(28,16,8,.06); transition: all .3s;
        }
        .valeur-card:hover { transform: translateY(-5px); box-shadow: 0 16px 40px rgba(28,16,8,.1); }

        .etape-card {
          background: white; border-radius: 16px; padding: 28px;
          border: 1.5px solid rgba(28,16,8,.06); position: relative;
          transition: all .3s;
        }
        .etape-card.active { border-color: #C4441A; background: rgba(196,68,26,.02); }

        @keyframes fadeUp { from { opacity:0; transform:translateY(20px); } to { opacity:1; transform:translateY(0); } }
        .fade-up { animation: fadeUp .6s ease forwards; }

        .stats-grid { display: grid; grid-template-columns: repeat(4,1fr); gap: 24px; }
        .valeurs-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 20px; }
        .etapes-grid { display: grid; grid-template-columns: repeat(2,1fr); gap: 20px; }

        @media(max-width:1199px) {
          .stats-grid { grid-template-columns: repeat(2,1fr); }
          .valeurs-grid { grid-template-columns: repeat(2,1fr); }
        }
        @media(max-width:767px) {
          .stats-grid { grid-template-columns: repeat(2,1fr); }
          .valeurs-grid { grid-template-columns: 1fr; }
          .etapes-grid { grid-template-columns: 1fr; }
          .hero-mission { padding: 80px 5% 60px !important; }
          .mission-content { padding: 48px 5% 60px !important; }
        }
      `}</style>

      <Navbar transparent={false} />

      {/* ── HERO ─────────────────────────────────────────────── */}
      <section className="hero-mission" style={{
        background: "linear-gradient(135deg, #1C1008 0%, #2D1A08 100%)",
        padding: "110px 5% 80px", position: "relative", overflow: "hidden",
      }}>
        <div style={{ position:"absolute", inset:0, backgroundImage:"url(https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?w=1400&q=80)", backgroundSize:"cover", backgroundPosition:"center", opacity:.08 }} />
        <div style={{ position:"absolute", width:500, height:500, borderRadius:"50%", background:"#C4441A", top:-150, right:-100, filter:"blur(120px)", opacity:.12 }} />
        <div style={{ position:"absolute", inset:0, backgroundImage:"radial-gradient(circle, rgba(196,68,26,.07) 1px, transparent 1px)", backgroundSize:"28px 28px" }} />

        <div style={{ maxWidth:900, margin:"0 auto", position:"relative", zIndex:1, textAlign:"center" }}>
          <div className="fade-up" style={{ display:"inline-flex", alignItems:"center", gap:8, background:"rgba(196,68,26,.2)", border:"1px solid rgba(196,68,26,.3)", borderRadius:6, padding:"6px 16px", marginBottom:24 }}>
            <span style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:11, fontWeight:700, color:"#E8834A", letterSpacing:2, textTransform:"uppercase" }}>
              Notre mission
            </span>
          </div>

          <h1 className="fade-up" style={{ fontSize:"clamp(32px,5.5vw,64px)", fontWeight:800, color:"white", lineHeight:1.1, letterSpacing:"-2px", marginBottom:24 }}>
            La plateforme qui rassemble toutes les{" "}
            <span style={{ color:"#E8834A", fontStyle:"italic" }}>expériences touristiques</span>
            {" "}du Sénégal en un seul endroit
          </h1>

          <p className="fade-up" style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:"clamp(15px,2vw,18px)", color:"rgba(255,255,255,.65)", lineHeight:1.8, maxWidth:680, margin:"0 auto 40px" }}>
            SenuTour est née d'un constat simple : le Sénégal regorge de merveilles touristiques, mais elles sont dispersées, difficiles à trouver et souvent invisibles pour les visiteurs. Notre mission est de changer ça.
          </p>

          <div className="fade-up" style={{ display:"flex", gap:12, justifyContent:"center", flexWrap:"wrap" }}>
            <button onClick={() => navigate("/inscription")}
              style={{ background:"#C4441A", color:"white", border:"none", padding:"14px 28px", borderRadius:8, fontFamily:"'Space Grotesk',sans-serif", fontSize:15, fontWeight:700, cursor:"pointer", transition:"all .3s" }}
              onMouseEnter={e => e.currentTarget.style.background = "#A03614"}
              onMouseLeave={e => e.currentTarget.style.background = "#C4441A"}>
              Rejoindre SenuTour →
            </button>
            <button onClick={() => navigate("/contact")}
              style={{ background:"transparent", color:"white", border:"1.5px solid rgba(255,255,255,.25)", padding:"14px 24px", borderRadius:8, fontFamily:"'Space Grotesk',sans-serif", fontSize:15, fontWeight:600, cursor:"pointer", transition:"all .3s" }}
              onMouseEnter={e => e.currentTarget.style.borderColor = "white"}
              onMouseLeave={e => e.currentTarget.style.borderColor = "rgba(255,255,255,.25)"}
            >
              Nous contacter
            </button>
          </div>
        </div>
      </section>

      {/* ── STATS ─────────────────────────────────────────────── */}
      <section style={{ background:"#C4441A", padding:"48px 5%" }}>
        <div style={{ maxWidth:1200, margin:"0 auto" }}>
          <div className="stats-grid">
            {chiffres.map((s, i) => (
              <div key={i} style={{ textAlign:"center" }}>
                <div style={{ fontFamily:"'Fraunces',serif", fontSize:"clamp(28px,4vw,48px)", fontWeight:800, color:"white", lineHeight:1 }}>{s.val}</div>
                <div style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:13, fontWeight:600, color:"rgba(255,255,255,.85)", marginTop:6 }}>{s.label}</div>
                <div style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:11, color:"rgba(255,255,255,.5)", marginTop:3 }}>{s.sub}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="mission-content" style={{ padding:"80px 5%" }}>
        <div style={{ maxWidth:1200, margin:"0 auto" }}>

          {/* ── HISTOIRE ── */}
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:64, alignItems:"center", marginBottom:80 }}>
            <div>
              <span style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:11, fontWeight:700, letterSpacing:3, color:"#C4441A", textTransform:"uppercase", display:"block", marginBottom:14 }}>Notre histoire</span>
              <h2 style={{ fontFamily:"'Fraunces',serif", fontSize:"clamp(26px,4vw,42px)", fontWeight:800, letterSpacing:"-1px", lineHeight:1.2, marginBottom:20 }}>
                Construite par des Sénégalais, pour le monde entier
              </h2>
              <p style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:15, color:"#7A5A3A", lineHeight:1.85, marginBottom:16 }}>
  SenuTour est née d'une idée simple portée par une équipe de jeunes entrepreneurs sénégalais : pourquoi les touristes qui visitent notre pays doivent-ils chercher sur des dizaines de sites étrangers ce qu'ils pourraient trouver en un seul clic, sur une plateforme qui connaît vraiment le Sénégal ?
</p>
              <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
                {[
                  "Fondée en 2026 à Dakar, Sénégal",
                  "100% développée par des talents locaux",
                  "Objectif : 14 régions du Sénégal couvertes",
                  "Vision : devenir le Booking.com de l'Afrique de l'Ouest",
                ].map((item, i) => (
                  <div key={i} style={{ display:"flex", alignItems:"center", gap:10 }}>
                    <IconCheck size={15} color="#3D6B2E" />
                    <span style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:14, color:"#1C1008" }}>{item}</span>
                  </div>
                ))}
              </div>
            </div>

            <div style={{ position:"relative" }}>
              <div style={{ borderRadius:20, overflow:"hidden", boxShadow:"0 24px 64px rgba(28,16,8,.15)" }}>
                <img src="https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?w=700&q=80" alt="Sénégal" style={{ width:"100%", height:420, objectFit:"cover", display:"block" }} />
                <div style={{ position:"absolute", inset:0, background:"linear-gradient(to top, rgba(28,16,8,.5) 0%, transparent 60%)", borderRadius:20 }} />
              </div>
              <div style={{ position:"absolute", bottom:-20, left:-20, background:"#C4441A", borderRadius:14, padding:"18px 22px", boxShadow:"0 12px 32px rgba(196,68,26,.4)" }}>
                <div style={{ fontFamily:"'Fraunces',serif", fontSize:28, fontWeight:800, color:"white" }}>2026</div>
                <div style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:12, color:"rgba(255,255,255,.8)" }}>Année de création</div>
              </div>
              <div style={{ position:"absolute", top:-20, right:-20, background:"white", borderRadius:14, padding:"18px 22px", boxShadow:"0 12px 32px rgba(28,16,8,.12)" }}>
                <div style={{ fontFamily:"'Fraunces',serif", fontSize:28, fontWeight:800, color:"#C4441A" }}>🇸🇳</div>
                <div style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:12, color:"#7A5A3A" }}>Made in Sénégal</div>
              </div>
            </div>
          </div>

          {/* ── VALEURS ── */}
          <div style={{ marginBottom:80 }}>
            <div style={{ textAlign:"center", marginBottom:48 }}>
              <span style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:11, fontWeight:700, letterSpacing:3, color:"#C4441A", textTransform:"uppercase", display:"block", marginBottom:12 }}>Nos valeurs</span>
              <h2 style={{ fontFamily:"'Fraunces',serif", fontSize:"clamp(26px,4vw,42px)", fontWeight:800, letterSpacing:"-1px" }}>
                Ce qui nous guide chaque jour
              </h2>
            </div>
            <div className="valeurs-grid">
              {valeurs.map((v, i) => (
                <div key={i} className="valeur-card">
                  <div style={{ width:52, height:52, borderRadius:13, background:"rgba(196,68,26,.08)", display:"flex", alignItems:"center", justifyContent:"center", marginBottom:16 }}>
                    {v.icon}
                  </div>
                  <h3 style={{ fontFamily:"'Fraunces',serif", fontSize:19, fontWeight:700, marginBottom:10 }}>{v.titre}</h3>
                  <p style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:14, color:"#7A5A3A", lineHeight:1.75 }}>{v.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* ── ROADMAP ── */}
          <div style={{ marginBottom:80 }}>
            <div style={{ textAlign:"center", marginBottom:48 }}>
              <span style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:11, fontWeight:700, letterSpacing:3, color:"#C4441A", textTransform:"uppercase", display:"block", marginBottom:12 }}>Notre plan</span>
              <h2 style={{ fontFamily:"'Fraunces',serif", fontSize:"clamp(26px,4vw,42px)", fontWeight:800, letterSpacing:"-1px" }}>
                Comment on construit SenuTour
              </h2>
              <p style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:15, color:"#7A5A3A", marginTop:12, maxWidth:500, margin:"12px auto 0" }}>
                On ne fait pas tout d'un coup. On construit progressivement, en commençant par ce qui crée le plus de valeur immédiate.
              </p>
            </div>
            <div className="etapes-grid">
              {etapes.map((e, i) => (
                <div key={i} className={`etape-card ${e.actif ? "active" : ""}`}>
                  {e.actif && (
                    <div style={{ position:"absolute", top:16, right:16, background:"#C4441A", borderRadius:20, padding:"3px 10px" }}>
                      <span style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:10, fontWeight:700, color:"white" }}>EN COURS</span>
                    </div>
                  )}
                  <div style={{ fontFamily:"'Fraunces',serif", fontSize:40, fontWeight:800, color: e.actif ? "#C4441A" : "rgba(28,16,8,.1)", lineHeight:1, marginBottom:12 }}>{e.num}</div>
                  <h3 style={{ fontFamily:"'Fraunces',serif", fontSize:20, fontWeight:700, marginBottom:10 }}>{e.titre}</h3>
                  <p style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:14, color:"#7A5A3A", lineHeight:1.7 }}>{e.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* ── CTA FINAL ── */}
          <div style={{ background:"linear-gradient(135deg, #1C1008 0%, #2D1A08 100%)", borderRadius:20, padding:"56px 48px", textAlign:"center", position:"relative", overflow:"hidden" }}>
            <div style={{ position:"absolute", width:300, height:300, borderRadius:"50%", background:"#C4441A", top:-80, right:-60, filter:"blur(80px)", opacity:.15 }} />
            <div style={{ position:"relative", zIndex:1 }}>
              <h2 style={{ fontFamily:"'Fraunces',serif", fontSize:"clamp(24px,4vw,42px)", fontWeight:800, color:"white", letterSpacing:"-1px", marginBottom:16, lineHeight:1.2 }}>
                Rejoignez l'aventure SenuTour
              </h2>
              <p style={{ fontFamily:"'Space Grotesk',sans-serif", fontSize:15, color:"rgba(255,255,255,.6)", lineHeight:1.7, maxWidth:480, margin:"0 auto 32px" }}>
                Touriste, propriétaire de villa, restaurateur ou guide — SenuTour a besoin de vous pour construire le tourisme de demain au Sénégal.
              </p>
              <div style={{ display:"flex", gap:12, justifyContent:"center", flexWrap:"wrap" }}>
                <button onClick={() => navigate("/inscription")}
                  style={{ background:"#C4441A", color:"white", border:"none", padding:"14px 28px", borderRadius:8, fontFamily:"'Space Grotesk',sans-serif", fontSize:15, fontWeight:700, cursor:"pointer", transition:"all .3s" }}
                  onMouseEnter={e => e.currentTarget.style.background = "#A03614"}
                  onMouseLeave={e => e.currentTarget.style.background = "#C4441A"}>
                  S'inscrire gratuitement →
                </button>
                <button onClick={() => navigate("/contact")}
                  style={{ background:"transparent", color:"white", border:"1.5px solid rgba(255,255,255,.25)", padding:"14px 24px", borderRadius:8, fontFamily:"'Space Grotesk',sans-serif", fontSize:15, fontWeight:600, cursor:"pointer" }}>
                  Nous contacter
                </button>
              </div>
            </div>
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
}